$(function(){

  var headerWrapHeight = $(".header-wrap").outerHeight();
  var headerHeight = $(".site-header").outerHeight();
  if($('body').hasClass('template-index')){

  } else {
    $('.main-content').css("padding-top", headerWrapHeight);
    $('.template-collection .collection-filter').css("top", headerHeight + 8);
    $('.grid__item--sidebar').css("top", headerWrapHeight + 16);
    $('.grid__item--sidebar').css("top", 90);
  }

  var header = $('.site-header');
  var shippingBar = $('.shipping-banner');
  var announceBar = $('.announcement-bar');

  $(window).scroll(function () {
    var s = $(this).scrollTop();
    var m = 200;
    if(s > m) {
      header.addClass('opacity');
      $('.toolbar--transparent').addClass('opacity');
      shippingBar.hide();
      announceBar.hide();
    } else if(s < m) {
      header.removeClass('opacity');
      $('.toolbar--transparent').removeClass('opacity');
      shippingBar.show();
      announceBar.show();
    }
  });


  var cartBtn = $('.template-cart .cart__checkout')
  var input = $('input[name="cartAttention"]')
  var otherBtns = $('.additional-checkout-buttons')
  cartBtn.prop('disabled', true);

  input.change(function() {
    var prop = input.prop('checked');
    if (prop) {
      cartBtn.removeClass('disable');
      cartBtn.prop('disabled', false);
      otherBtns.show();
    } else {
      cartBtn.addClass('disable');
      cartBtn.prop('disabled', true);
      otherBtns.hide();
    }
  });


  $('.drawer__contents__list__item--acc:first-child').addClass('active');

  $('.drawer__contents__list__item--acc > a').on('click',function(){
    $('.drawer__contents__list--middle').hide();
    $('.drawer__contents__list__item').removeClass('active');
    $(this).closest('.drawer__contents__list__item').addClass('active');
    $(this).closest('.drawer__contents__list__item').find('.drawer__contents__list--middle').fadeIn();
  });

  $('.drawer__contents_list__item__acc-btn').on('click',function(){
    $(this).closest('.drawer__contents__list__item').toggleClass('active');
    $(this).closest('.drawer__contents__list__item').find('.drawer__contents__list--small').slideToggle();
  });

  $('#NavDrawer .js-search-header').on('click',function(){
    $('#NavDrawer .js-drawer-close').click();
  });

  var closeSearch = $('.close-search');
  // var btnCloseSearch = $('.predictive__screen');
  closeSearch.on('click',function(){
    $('.predictive-search-wrap').removeClass('is-active');
    $('.site-header__search-container').removeClass('is-active');
    $('body').removeClass('predictive-overflow-hidden');
    return false;
  });

});


$(function () {
  $('a[href^="#"]').click(function(e) {
     var href = $(this).attr("href");
     var target = $(href == "#" || href == "" ? 'html' : href);
     var headerHeight = $(".site-header").outerHeight();
     var position = target.offset().top - headerHeight;

     $.when(
       $("html, body").animate({
         scrollTop: position
       }, 400, "swing"),
       e.preventDefault(),
     ).done(function() {
       var diff = target.offset().top - headerHeight;
       if (diff === position) {
       } else {
         $("html, body").animate({
           scrollTop: diff
         }, 10, "swing");
       }
     });
   });
});

$(window).on('load', function() {
	// ページのURLを取得
	const url = $(location).attr('href'),
	// headerの高さを取得して値をheaderHeightに代入
	headerHeight = $('.site-header').outerHeight() + 10;
	// urlに「#」が含まれていれば
	if(url.indexOf("#") != -1){
		// urlを#で分割して配列に格納
		const anchor = url.split("#"),
		// 分割した最後の文字列（#◯◯の部分）をtargetに代入
		target = $('#' + anchor[anchor.length - 1]),
		// リンク先の位置からheaderHeightの高さを引いた値をpositionに代入
		position = Math.floor(target.offset().top) - headerHeight;
		// positionの位置に移動
		$("html, body").animate({scrollTop:position}, 400, "swing");
	}
});


$(function () {
  $('.faq dd').hide();
  $('.faq dt').on('click', function () {
    $(this).siblings('dd').slideToggle();
    $(this).parent('dl').toggleClass('open');
  });
});